import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Grid,
  Button
} from "@mui/material";
import {useNavigate} from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';


const UserComponent = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState(null);
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isAdmin, setIsAdmin] = useState(false);
  const [allowMasterAdd, setAllowMasterAdd] = useState(false);
  const [allowMasterEdit, setAllowMasterEdit] = useState(false);
  const [allowMasterDelete, setAllowMasterDelete] = useState(false);
  const [allowEntryAdd, setAllowEntryAdd] = useState(false);
  const [allowEntryEdit, setAllowEntryEdit] = useState(false);
  const [allowEntryDelete, setAllowEntryDelete] = useState(false);
  const [allowBackdatedEntry, setAllowBackdatedEntry] = useState(false);
  const [passwordHint, setPasswordHint] = useState('');
  const [fullName, setFullName] = useState('');
  const [showGrid, setShowGrid] = useState('');
  const [users, setUsers] = useState([]);
  const [formMode, setFormMode] = useState('add');
  const [passwordError, setPasswordError] = useState('');
  const [compCode, setCompCode] = useState(null);
  const [compMasterEntries, setCompMasterEntries] = useState([]);
  
  // const [editUser, setEditUser] = useState(null);



  useEffect(() => {
    fetchUsers();
    fetchCompMaster();
  }, []);

  const fetchUsers = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/getusers');
      //console.log(response); // Check the response structure
      setUsers(response.data); // Assuming response.data.users is an array
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const fetchCompMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/company');
        setCompMasterEntries(response.data);
    } catch (error) {
      console.log("Error:", error);
    }
  };

  const handleSave = async () => {
    if (password !== confirmPassword) {
      toast.error("Passwords Do Not Match",{autoClose:680});
      setPassword('');
      setConfirmPassword('');
      return;
    }
    const userData = {
      username,
      password,
      isAdmin,
      allowMasterAdd,
      allowMasterEdit,
      allowMasterDelete,
      allowEntryAdd,
      allowEntryEdit,
      allowEntryDelete,
      allowBackdatedEntry,
      passwordHint,
      compcode: compCode
    };

    try {
      const response = await axios.post('https://www.wingap.net.in/api/users', userData);
      //console.log(response.data); // Assuming the API sends a response message
      toast.success("User Added Sucessfully.....!",{autoClose:680 });
      resetform();
      fetchUsers();
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const handleCancel = () => {
    // Your cancel logic here
    console.log('Cancel clicked');
  };

  const updateRoom = async (username) => {
    try {
      await axios.put(`https://www.wingap.net.in/api/updateUser/${username}`, {
        username: username,
        password: password,
        isAdmin: isAdmin,
        allowMasterAdd: allowMasterAdd,
        allowMasterEdit: allowMasterEdit,
        allowMasterDelete: allowMasterDelete,
        allowEntryAdd: allowEntryAdd,
        allowEntryEdit: allowEntryEdit,
        allowEntryDelete: allowEntryDelete,
        allowBackdatedEntry: allowBackdatedEntry,
        passwordHint: passwordHint,
        compcode: compCode
      });
      setUsername(null);
      toast.success("User Updated Sucessfully.....!",{autoClose:680 });
      setPassword('');
      setConfirmPassword('');
      setIsAdmin('');
      setAllowMasterAdd('');
      setAllowMasterEdit('');
      setAllowMasterDelete('');
      setAllowEntryAdd('');
      setAllowEntryEdit('');
      setAllowEntryDelete('');
      setAllowBackdatedEntry('');
      setPasswordHint('');
      setFullName('');
      setCompCode('');
      setFormMode('add');
      fetchUsers();
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const resetform = () => {
    setFormMode('add');
    setUsername('');
    setPassword('');
    setConfirmPassword('');
    setIsAdmin('');
    setAllowMasterAdd('');
    setAllowMasterEdit('');
    setAllowMasterDelete('');
    setAllowEntryAdd('');
    setAllowEntryEdit('');
    setAllowEntryDelete('');
    setAllowBackdatedEntry('');
    setPasswordHint('');
    setFullName('');
    setPasswordError('');
    setCompCode('');
  }

  const setEditForm = (user) => {
    setFormMode('edit');
    setUsername(user.UserName);
    setPassword('');
    setConfirmPassword('');
    // setPassword(user.Password);
    // setConfirmPassword(user.Password);
    setIsAdmin(user.Administrator);
    setAllowMasterAdd(user.AllowMasterAdd);
    setAllowMasterEdit(user.AllowMasterEdit);
    setAllowMasterDelete(user.AllowMasterDelete);
    setAllowEntryAdd(user.AllowEntryAdd);
    setAllowEntryEdit(user.AllowEntryEdit);
    setAllowEntryDelete(user.AllowEntryDelete);
    setAllowBackdatedEntry(user.AllowBackdatedEntry);
    setPasswordHint(user.Passwordhint);
    setCompCode(user.Remark);
    setShowGrid(false);
  };

  const handleCompChange = (e) => {
    const selectedGroupName = e.target.value;
    setCompCode(selectedGroupName);

    const selectedGroup = compMasterEntries.find(group => group.CompCode == selectedGroupName);
    if (selectedGroup) {
      setCompCode(selectedGroup.CompCode);
    } else {
      setCompCode(null);
    }
  };

  const handleshowandhide = () => {
    setShowGrid(!showGrid);
  }

  const handleExitButtonClick = () => {
    navigate('/Dashboard');
  };

  const deleteRoom = async (UserName) => {
    try {
      await axios.delete(`https://www.wingap.net.in/api/deleteUser/${UserName}`);
      fetchUsers();
    } catch (error) {
      console.log('Error:', error);
    }
  };

  return (
    <div style={styles.formContainer}>
      <ToastContainer />
      <Grid item>
        <Button
          variant="contained"
          className="view-button"
          onClick={handleshowandhide}
          sx={{ backgroundColor: "blue", color: "white", marginBottom: "20px", float: 'right', position: 'relative', marginTop: '0px', marginRight: '-120px' }}
        >
          {showGrid ? 'Back' : 'Show All Users'}
        </Button>
      </Grid>
      {!showGrid && (
        <Grid item>
          <Button
            variant="contained"
            className="view-button"
            onClick={handleExitButtonClick}
            sx={{
              backgroundColor: "red",
              color: "white",
              marginBottom: "20px",
              float: "right",
              marginRight: "10px",
            }}
          >
            Exit
          </Button>
        </Grid>
      )}
      {!showGrid && <form >
        <h2>Create New User</h2>
        <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '10px' }}>
          {[
            { label: 'Username', value: username, onChange: (e) => setUsername(e.target.value) },
            { label: 'Password', value: password, onChange: (e) => setPassword(e.target.value) },
            { label: 'Confirm Password', value: confirmPassword, onChange: (e) => setConfirmPassword(e.target.value) },
            { label: 'Password Hint', value: passwordHint, onChange: (e) => setPasswordHint(e.target.value) },
            { label: 'Full Name', value: fullName, onChange: (e) => setFullName(e.target.value) },
          ].map(({ label, value, onChange }, index) => (
            <div key={index} style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
              <label htmlFor={label} style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>{label}</label>
              <input
                type="text"
                value={value}
                onChange={onChange}
                placeholder={label}
                style={{ marginBottom: '5px', padding: '5px', width: '40%' }}
              />
            </div>
          ))}
          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor='company' style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>Select Company</label>
            <select
              value={compCode}
              onChange={handleCompChange}
              style={{ padding: '6px', width: '35%' }}>
              <option value=" ">Select Company</option>
              <option value="0">All Company</option>
              {compMasterEntries.map((group) => (
                <option key={group.CompCode} value={group.CompCode}>{group.CompName}</option>
              ))}
            </select>
          </div>
        </div>
        <div className="form-check">
          <input type="checkbox" className="form-check-input" id="isAdmin" checked={isAdmin} onChange={(e) => setIsAdmin(e.target.checked)} />
          <label className="form-check-label" htmlFor="isAdmin">Administrator</label>
        </div>

        <div style={styles.permissionsContainer}>
          <div style={styles.permissionsSection}>
            <h3>Master Permissions</h3>
            <div className="form-check">
              <input type="checkbox" className="form-check-input" id="allowMasterAdd" checked={allowMasterAdd} onChange={(e) => setAllowMasterAdd(e.target.checked)} />
              <label className="form-check-label" htmlFor="allowMasterAdd">Allow Master Add</label>
            </div>
            <div className="form-check">
              <input type="checkbox" className="form-check-input" id="allowMasterEdit" checked={allowMasterEdit} onChange={(e) => setAllowMasterEdit(e.target.checked)} />
              <label className="form-check-label" htmlFor="allowMasterEdit">Allow Master Edit</label>
            </div>
            <div className="form-check">
              <input type="checkbox" className="form-check-input" id="allowMasterDelete" checked={allowMasterDelete} onChange={(e) => setAllowMasterDelete(e.target.checked)} />
              <label className="form-check-label" htmlFor="allowMasterDelete">Allow Master Delete</label>
            </div>
          </div>
          <div style={styles.permissionsSection}>
            <h3>Transaction Permissions</h3>
            <div className="form-check">
              <input type="checkbox" className="form-check-input" id="allowEntryAdd" checked={allowEntryAdd} onChange={(e) => setAllowEntryAdd(e.target.checked)} />
              <label className="form-check-label" htmlFor="allowEntryAdd">Allow Entry Add</label>
            </div>
            <div className="form-check">
              <input type="checkbox" className="form-check-input" id="allowEntryEdit" checked={allowEntryEdit} onChange={(e) => setAllowEntryEdit(e.target.checked)} />
              <label className="form-check-label" htmlFor="allowEntryEdit">Allow Entry Edit</label>
            </div>
            <div className="form-check">
              <input type="checkbox" className="form-check-input" id="allowEntryDelete" checked={allowEntryDelete} onChange={(e) => setAllowEntryDelete(e.target.checked)} />
              <label className="form-check-label" htmlFor="allowEntryDelete">Allow Entry Delete</label>
            </div>
            <div className="form-check">
              <input type="checkbox" className="form-check-input" id="allowBackdatedEntry" checked={allowBackdatedEntry} onChange={(e) => setAllowBackdatedEntry(e.target.checked)} />
              <label className="form-check-label" htmlFor="allowBackdatedEntry">Allow Backdated Entry</label>
            </div>
          </div>
        </div>

        <div className="form-group">
          <button type="button"
            className={formMode === 'add' ? 'add-button' : 'update-button'}
            onClick={formMode === 'add' ? handleSave : () => updateRoom(username)}
            style={{
              padding: '10px 20px',
              fontSize: '16px',
              margin: '0 10px',
              cursor: 'pointer',
              backgroundColor: formMode === 'add' ? '#4caf50' : '#2196f3',
              color: 'white'
            }}>
            {formMode === 'add' ? 'Add' : 'Update'}
          </button>
          <button type="button" onClick={resetform} className="btn btn-secondary" style={{ padding: '10px 20px', fontSize: '16px', margin: '0 10px', cursor: 'pointer', backgroundColor: '#f44336', color: 'white', }} >Cancel</button>
        </div>
      </form>}
      {showGrid && <div style={{ width: '100%' }}>
        <h2>User Entries</h2>
        <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #ccc' }}>
          <thead>
            <tr style={{ background: '#f2f2f2', color: 'black' }}>
              <th
                style={{
                  padding: '8px',
                  background: '#f2f2f2',
                  border: '1px solid #ccc',
                }}
              >
                UserName
              </th>
              {/* <th
                      style={{
                        padding: '8px',
                        background: '#f2f2f2',
                        border: '1px solid #ccc',
                      }}
                    >
                      Password
                    </th> 
                    <th
                      style={{
                        padding: '8px',
                        background: '#f2f2f2',
                        border: '1px solid #ccc',
                      }}
                    >
                      Passwordhint
                    </th> */}
              <th
                style={{
                  padding: '8px',
                  background: '#f2f2f2',
                  border: '1px solid #ccc',
                }}
              >
                Actions
              </th>

            </tr>
          </thead>
          <tbody>
            {users.map((user) => (
              <tr key={user.UserName} style={{
                backgroundColor: 'white', color: 'black', textAlign
                  : 'center'
              }}>
                <td style={{ padding: '8px', border: '1px solid #ccc' }}>{user.UserName}</td>
                {/* <td style={{ padding: '8px', border: '1px solid #ccc' }}>{user.Password}</td>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{user.Passwordhint}</td> */}
                <td>
                  <button
                    style={{
                      padding: '5px 10px',
                      backgroundColor: 'rgb(76, 175, 80)',
                      color: 'white',
                      border: 'none',
                      cursor: 'pointer',
                      marginRight: '5px',
                      marginLeft: '10px',
                    }}
                    onClick={() => setEditForm(user)}
                  >
                    Edit
                  </button>
                  <button
                    style={{
                      padding: '5px 10px',
                      backgroundColor: 'rgb(244, 67, 54)',
                      color: 'white',
                      border: 'none',
                      cursor: 'pointer',
                    }}
                    onClick={() => deleteRoom(user.UserName)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>}
    </div>

  );
};

const styles = {
  formContainer: {
    maxWidth: '80%',
    margin: '0 auto',
    padding: '20px',
  },
  permissionsContainer: {
    display: 'flex',
    marginBottom: '20px',
  },
  permissionsSection: {
    marginRight: '10px',
    padding: '5px',
    border: '1px solid #ccc',
    borderRadius: '5px',
  },
};

export default UserComponent;




// import React, { useState , useEffect } from 'react';
// import axios from 'axios';
// import {
//   Grid,
//   Button
// } from "@mui/material";
// import Swal from 'sweetalert2';
// import withReactContent from 'sweetalert2-react-content';

// const MySwal = withReactContent(Swal);

// const showDuplicateEntryAlert = () => {
//   MySwal.fire({
//       title: <strong>Warning</strong>,
//       html: (
//           <>
//               <p>Please Enter Password...<br />
//               Before Update</p>
//           </>
//       ),
//       icon: 'warning',
//       confirmButtonColor: '#1976d2',
//       confirmButtonText: 'OK',
//   });
// };


// const UserComponent = () => {
//   const [username, setUsername] = useState(null);
//   const [password, setPassword] = useState('');
//   const [confirmPassword, setConfirmPassword] = useState('');
//   const [isAdmin, setIsAdmin] = useState(false);
//   const [allowMasterAdd, setAllowMasterAdd] = useState(false);
//   const [allowMasterEdit, setAllowMasterEdit] = useState(false);
//   const [allowMasterDelete, setAllowMasterDelete] = useState(false);
//   const [allowEntryAdd, setAllowEntryAdd] = useState(false);
//   const [allowEntryEdit, setAllowEntryEdit] = useState(false);
//   const [allowEntryDelete, setAllowEntryDelete] = useState(false);
//   const [allowBackdatedEntry, setAllowBackdatedEntry] = useState(false);
//   const [passwordHint, setPasswordHint] = useState('');
//   const [fullName, setFullName] = useState('');
//   const [showGrid, setShowGrid] = useState('');
//   const [users, setUsers]= useState([]);
//   const [formMode, setFormMode] = useState('add');
//   const [passwordError, setPasswordError] = useState('');

//   useEffect(() => {
//     fetchUsers();
//   }, []);

//   const fetchUsers = async () => {
//     try {
//       const response = await axios.get('https://www.wingap.net.in/api/getusers');
//       console.log(response); // Check the response structure
//       setUsers(response.data); // Assuming response.data.users is an array
//     } catch (error) {
//       console.log('Error:', error);
//     }
//   };
  
//   const handleSave = async () => {
//     if (password !== confirmPassword) {
//       setPasswordError("Passwords do not match");
//       return;
//     }
//     const userData = {
//       username,
//       password, 
//       isAdmin,
//       allowMasterAdd,
//       allowMasterEdit,
//       allowMasterDelete,
//       allowEntryAdd,
//       allowEntryEdit,
//       allowEntryDelete,
//       allowBackdatedEntry,
//       passwordHint,
//     };

//     try {
//       const response = await axios.post('https://www.wingap.net.in/api/users', userData);
//       console.log(response.data);
//       resetform();
//       fetchUsers();
//       setPasswordError('');
//     } catch (error) {
//       console.error('Error:', error);
//     }
//   };

//   const handleCancel = () => {
//     // Your cancel logic here
//     console.log('Cancel clicked');
//   };

//   const updateRoom = async (username) => {
//     if (!password) {
//       showDuplicateEntryAlert(); 
//       return; 
//     }
//     try {
//       await axios.put(`https://www.wingap.net.in/api/updateUser/${username}`, {
//         username:username,
//         password:password, 
//         isAdmin:isAdmin,
//         allowMasterAdd:allowMasterAdd,
//         allowMasterEdit:allowMasterEdit,
//         allowMasterDelete:allowMasterDelete,
//         allowEntryAdd:allowEntryAdd,
//         allowEntryEdit:allowEntryEdit,
//         allowEntryDelete: allowEntryDelete,
//         allowBackdatedEntry:allowBackdatedEntry,
//         passwordHint:passwordHint,
//       });
//       setUsername(null);
//       setPassword('');
//       setConfirmPassword('');
//       setIsAdmin('');
//       setAllowMasterAdd('');
//       setAllowMasterEdit('');
//       setAllowMasterDelete('');
//       setAllowEntryAdd('');
//       setAllowEntryEdit('');
//       setAllowEntryDelete('');
//       setAllowBackdatedEntry('');
//       setPasswordHint('');
//       setFullName('');
//       setFormMode('add');
//       fetchUsers();
//     } catch (error) {
//       console.log('Error:', error);
//     }
//   };

//   const resetform = () =>{
//     setFormMode('add');
//     setUsername('');
//     setPassword('');
//     setConfirmPassword('');
//     setIsAdmin('');
//     setAllowMasterAdd('');
//     setAllowMasterEdit('');
//     setAllowMasterDelete('');
//     setAllowEntryAdd('');
//     setAllowEntryEdit('');
//     setAllowEntryDelete('');
//     setAllowBackdatedEntry('');
//     setPasswordHint('');
//     setFullName('');
//     setPasswordError('');
//   }

//   const setEditForm = (user) => {
//     setFormMode('edit');
//     setUsername(user.UserName);
//     setPassword('');
//     setConfirmPassword('');
//     setIsAdmin(user.Administrator);
//     setAllowMasterAdd(user.AllowMasterAdd);
//     setAllowMasterEdit(user.AllowMasterEdit);
//     setAllowMasterDelete(user.AllowMasterDelete);
//     setAllowEntryAdd(user.AllowEntryAdd);
//     setAllowEntryEdit(user.AllowEntryEdit);
//     setAllowEntryDelete(user.AllowEntryDelete);
//     setAllowBackdatedEntry(user.AllowBackdatedEntry);
//     setPasswordHint(user.Passwordhint);
//     setShowGrid(false);
//   };

//   const handleshowandhide = () => {
//     setShowGrid(!showGrid);
    
//   }
//   const deleteRoom = async (UserName) => {
//     try {
//       await axios.delete(`https://www.wingap.net.in/api/deleteUser/${UserName}`);
//       fetchUsers();
//     } catch (error) {
//       console.log('Error:', error);
//     }
//   };

//   return (
//     <div style={styles.formContainer}>
//       <Grid item>
//           <Button
//             variant="contained"
//             className="view-button"
//             onClick={handleshowandhide}
//             sx={{ backgroundColor: "blue", color: "white", marginBottom: "20px", float:'right',position:'relative',marginTop:'0px', marginRight:'-120px'}}
//           >
//             {showGrid ? 'Hide Rooms' : 'Show Rooms'} 
//           </Button>
//         </Grid>
//       {!showGrid && <form >
//         <h2>User Form</h2>
//         <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '10px' }}>
//     <div style={{ color: 'red', marginBottom: '10px' }}>{passwordError}</div>
//     {[
//       { label: 'Username', value: username, onChange: (e) => setUsername(e.target.value) },
//       { label: 'Password', value: password, onChange: (e) => setPassword(e.target.value) },
//       { label: 'Confirm Password', value: confirmPassword, onChange: (e) => setConfirmPassword(e.target.value) },
//       { label: 'Password Hint', value: passwordHint, onChange: (e) => setPasswordHint(e.target.value) },
//       { label: 'Full Name', value: fullName, onChange: (e) => setFullName(e.target.value) },
//     ].map(({ label, value, onChange }, index) => (
//       <div key={index} style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
//         <label htmlFor={label} style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>{label}</label>
//         <input
//           type="text"
//           value={value}
//           onChange={onChange}
//           placeholder={label}
//           style={{ marginBottom: '5px', padding: '5px', width: '20%' }}
//         />
//       </div>
//     ))}
//   </div>
//         <div className="form-check">
//           <input type="checkbox" className="form-check-input" id="isAdmin" checked={isAdmin} onChange={(e) => setIsAdmin(e.target.checked)} />
//           <label className="form-check-label" htmlFor="isAdmin">Administrator</label>
//         </div>

//         <div style={styles.permissionsContainer}>
//           <div style={styles.permissionsSection}>
//             <h3>Master Permissions</h3>
//             <div className="form-check">
//               <input type="checkbox" className="form-check-input" id="allowMasterAdd" checked={allowMasterAdd} onChange={(e) => setAllowMasterAdd(e.target.checked)} />
//               <label className="form-check-label" htmlFor="allowMasterAdd">Allow Master Add</label>
//             </div>
//             <div className="form-check">
//               <input type="checkbox" className="form-check-input" id="allowMasterEdit" checked={allowMasterEdit} onChange={(e) => setAllowMasterEdit(e.target.checked)} />
//               <label className="form-check-label" htmlFor="allowMasterEdit">Allow Master Edit</label>
//             </div>
//             <div className="form-check">
//               <input type="checkbox" className="form-check-input" id="allowMasterDelete" checked={allowMasterDelete} onChange={(e) => setAllowMasterDelete(e.target.checked)} />
//               <label className="form-check-label" htmlFor="allowMasterDelete">Allow Master Delete</label>
//             </div>
//           </div>
//           <div style={styles.permissionsSection}>
//             <h3>Transaction Permissions</h3>
//             <div className="form-check">
//               <input type="checkbox" className="form-check-input" id="allowEntryAdd" checked={allowEntryAdd} onChange={(e) => setAllowEntryAdd(e.target.checked)} />
//               <label className="form-check-label" htmlFor="allowEntryAdd">Allow Entry Add</label>
//             </div>
//             <div className="form-check">
//               <input type="checkbox" className="form-check-input" id="allowEntryEdit" checked={allowEntryEdit} onChange={(e) => setAllowEntryEdit(e.target.checked)} />
//               <label className="form-check-label" htmlFor="allowEntryEdit">Allow Entry Edit</label>
//             </div>
//             <div className="form-check">
//               <input type="checkbox" className="form-check-input" id="allowEntryDelete" checked={allowEntryDelete} onChange={(e) => setAllowEntryDelete(e.target.checked)} />
//               <label className="form-check-label" htmlFor="allowEntryDelete">Allow Entry Delete</label>
//             </div>
//             <div className="form-check">
//               <input type="checkbox" className="form-check-input" id="allowBackdatedEntry" checked={allowBackdatedEntry} onChange={(e) => setAllowBackdatedEntry(e.target.checked)} />
//               <label className="form-check-label" htmlFor="allowBackdatedEntry">Allow Backdated Entry</label>
//             </div>
//           </div>
//         </div>

//         <div className="form-group">
//           <button type="button" 
//           className={formMode === 'add' ? 'add-button' : 'update-button'}
//           onClick={formMode === 'add' ? handleSave : () => updateRoom(username)}
//            style={{padding: '10px 20px',
//             fontSize: '16px',
//             margin: '0 10px',
//             cursor: 'pointer',
//             backgroundColor: formMode === 'add' ? '#4caf50' : '#2196f3' ,
//              color:'white'}}>
//               {formMode === 'add' ? 'Add' : 'Update'}
//               </button>
//           <button type="button" onClick={resetform} className="btn btn-secondary" style={{padding: '10px 20px',fontSize: '16px',margin: '0 10px',cursor: 'pointer', backgroundColor: '#f44336', color: 'white',}} >Cancel</button>
//         </div>
//       </form>}
//       {showGrid && <div style={{ width: '100%' }}>
//           <h2>User Entries</h2>
//           <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #ccc' }}>
//             <thead>
//             <tr style={{ background: '#f2f2f2', color:'black' }}>
//                     <th
//                       style={{
//                         padding: '8px',
//                         background: '#f2f2f2',
//                         border: '1px solid #ccc',
//                       }}
//                     >
//                       UserName
//                     </th>
//                     <th
//                       style={{
//                         padding: '8px',
//                         background: '#f2f2f2',
//                         border: '1px solid #ccc',
//                       }}
//                     >
//                       Password
//                     </th>
//                     <th
//                       style={{
//                         padding: '8px',
//                         background: '#f2f2f2',
//                         border: '1px solid #ccc',
//                       }}
//                     >
//                       Passwordhint
//                     </th>
//                     <th
//                       style={{
//                         padding: '8px',
//                         background: '#f2f2f2',
//                         border: '1px solid #ccc',
//                       }}
//                     >
//                       Actions
//                     </th>

//             </tr>        
//             </thead>
//             <tbody>
//               {users.map((user) => (
//                 <tr key={user.UserName} style={{ backgroundColor: 'white', color: 'black' , textAlign
//                 :'center'}}>
//                   <td style={{ padding: '8px', border: '1px solid #ccc' }}>{user.UserName}</td>
//                   <td style={{ padding: '8px', border: '1px solid #ccc' }}>{user.Password}</td>
//                   <td style={{ padding: '8px', border: '1px solid #ccc' }}>{user.Passwordhint}</td>
//                   <td>
//                         <button
//                           style={{
//                             padding: '5px 10px',
//                             backgroundColor: 'rgb(76, 175, 80)',
//                             color: 'white',
//                             border: 'none',
//                             cursor: 'pointer',
//                             marginRight: '5px',
//                             marginLeft:'10px',
//                           }}
//                           onClick={() => setEditForm(user)}
//                         >
//                           Edit
//                         </button>
//                         <button
//                           style={{
//                             padding: '5px 10px',
//                             backgroundColor: 'rgb(244, 67, 54)',
//                             color: 'white',
//                             border: 'none',
//                             cursor: 'pointer',
//                           }}
//                           onClick={() => deleteRoom(user.UserName)}
//                         >
//                           Delete
//                         </button>
//                       </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>}
//     </div>
    
//   );
// };

// const styles = {
//   formContainer: {
//     maxWidth: '80%',
//     margin: '0 auto',
//     padding: '20px',
//   },
//   permissionsContainer: {
//     display: 'flex',
//     marginBottom: '20px',
//   },
//   permissionsSection: {
//     marginRight:'10px',
//     padding: '5px',
//     border: '1px solid #ccc',
//     borderRadius: '5px',
//   },
// };

// export default UserComponent;
